export var shouldMockAgentData = function shouldMockAgentData() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
};